import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { Button } from '@components/main-components/button/Button';
import { Divider } from '@components/main-components/divider';

export const Placeholder = ({
  illustration,
  subHeading,
  text,
  buttonLabel,
  divider = false,
  mainFeed = false,
  ...props
}: {
  illustration: React.ReactNode;
  subHeading: string;
  text: string;
  buttonLabel: string;
  divider?: boolean;
  mainFeed?: boolean;
} & ({ href: string } | { onClick: () => void })) => {
  return (
    <Container divider={divider}>
      {divider && <StyledDivider orientation="horizontal" mainFeed={mainFeed} />}
      {illustration}
      <TextWrapper>
        <h2>{subHeading}</h2>
        <p>{text}</p>
        <Button
          href={'href' in props ? props.href : undefined}
          onClick={'onClick' in props ? props.onClick : undefined}
          variant="primary"
          label={buttonLabel}
          deprecatedCSS={{
            height: 'unset',
          }}
        />
      </TextWrapper>
    </Container>
  );
};

export const StyledDivider = styled(Divider, {
  height: 1,
  margin: '10px 0 40px',

  variants: {
    mainFeed: {
      true: {
        marginTop: 60,
      },
    },
  },
});

export const Container = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  height: '80vh',
  paddingX: 24,

  '@desktop': {
    paddingX: 0,
  },

  variants: {
    divider: {
      false: {
        paddingTop: 20,
      },
    },
  },
});

export const TextWrapper = styled('div', {
  marginTop: 30,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',

  h2: {
    base: 'M',
    fontStyle: 'semibold',
  },

  p: {
    base: 'M',
    maxWidth: 300,
    margin: '18px 0 24px',

    '@tablet': {
      maxWidth: 390,
    },
  },
});
